export const USER_API_ROUTES = {
  GET_SUBSCRIPTION: '/users/customers/subscription',
};
